import React from 'react'
import styled from 'styled-components'

import { Columns, DiscoverMore, H2, Image, Screen, Section } from 'ui'

const Container = styled(Section.White) `
  padding: 110px 30px;

  @media screen and (max-width: 640px) {
    padding-top: 100px;
  }
`

const Title = styled(H2) `
  margin: 0px auto 110px auto;

  @media screen and (max-width: 640px) {
    margin-bottom: 70px;
  }
`

const ClientsList = styled(Columns) `
  margin-left: -100px;
`

const ClientContainer = styled(Columns.Column) `
  margin-left: 100px;
  text-align: center;

  @media screen and (max-width: 640px) {
    img {
      max-width: 75%;
    }
  }
`

const Client = ({ image }) =>
  <ClientContainer>
    <Image src={ image } extension="png" />
  </ClientContainer>

const Clients = () => (
  <Container>
    <Screen>
      <Title>Clients in all industries</Title>
      <ClientsList>
        <Client image="/images/clients/salam" />
        <Client image="/images/clients/donisia" />
        <Client image="/images/clients/haute" />
        <Client image="/images/clients/aspria" />
      </ClientsList>
      <ClientsList>
        <Client image="/images/clients/caffe" />
        <Client image="/images/clients/coppolino" />
        <Client image="/images/clients/grandi-architetture-partners" />
        <Client image="/images/clients/giacomini" />
      </ClientsList>
      <DiscoverMore />
    </Screen>
  </Container>
)

export default Clients
